import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { EntInfosContainer, IconDiv, EICol, EntHeaderTitle, FormSelect, FormInputAgence } from '../Infos/Infos.styled'
import { EIFormCol, EIFormContainer } from '../../../containers/Entity/Entity.styled';
import { FormGroup, FormInput, FormLabel, TelInput } from '../../../styles/Common';
import { useTranslation } from 'react-i18next';
import MandatoryMarker from '../../UI/MandatoryMarker';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal'
import CancelIcon from '@mui/icons-material/Cancel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TH, THead, TBody, Table, TD } from '../../../styles/Table.styled';
import {  faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { getArbreJson, getNotyfObject } from '../../../shared/utility';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
function InfosLevel({ hierarchical, setHierarchical, niveau, setNiveau, userType, cannotBeModified }) {
    const { t } = useTranslation();
    const [showModalConfirmation, setShowModalConfirmation] = useState(false)
    const [indexLevelTodDelete,setIndexLevelToDelete]=useState()
    const notyf = getNotyfObject();
  const [open, setOpen] = useState(false);
    useEffect(() => {
    
    }, [hierarchical, niveau])

    const confirmeDeleteLevel = (index) => {
        let hierarchicalTemp = [...hierarchical]
        if (index == 0) {
            setNiveau([])
            setHierarchical([])
        } else {
            let tempNiveau = [...niveau]
            let temp = hierarchicalTemp?.filter((iteme, id) => iteme.index < index)
            setHierarchical(temp)
            tempNiveau.splice(index, 1)
            setNiveau(tempNiveau)
        }
        setShowModalConfirmation(false)
    }

    const deleteLevel = (index) => {
        setIndexLevelToDelete(index)
        setShowModalConfirmation(true)
 

    }

    const deleteElement = (index, indexOfOrigineLevel) => {
        let indexOfLastLevel = niveau.length - 1
        let tempHierarchical = [...hierarchical]
     
        if (indexOfLastLevel == indexOfOrigineLevel) {
            tempHierarchical.splice(index, 1)
            setHierarchical(tempHierarchical)

        } else {
            let libelle = niveau[indexOfOrigineLevel].libelle
            let value= tempHierarchical[index].libelle
            let nextElement = tempHierarchical.filter((iteme, id) => iteme.index == indexOfOrigineLevel + 1)
            let existe = nextElement.some((item) => item[libelle] == value)
            if (existe) {
                notyf.error("Vous ne pouvez pas supprimer cette ligne,Veuillez d'abord supprimer les lignes rattachées à cette dernière ");

            } else {
                tempHierarchical.splice(index, 1)
                setHierarchical(tempHierarchical)
            }
        }
    }

    const inputChangeHandlerLevel = (e, index) => {
        if (userType == "ADMIN_YOUNOV") {
            const key = e?.target.name;
            setNiveau((prevState) => {
                let newNiveau = [...prevState]
                newNiveau[index] = { ...newNiveau[index], [key]: e.target.value }
                return newNiveau
            })
        }
    }
    function hasEmptyProperty(obj) {
       
        for (let key in obj) {
            if (obj.hasOwnProperty(key) && key != "children") {
                if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                    return true; // Retourne true si une propriété est vide ou null
                }  
            }
        }
        return false; // Retourne false si aucune propriété vide ou null n'est trouvée
    }

    const addNewNiveau = (e) => {
        e.preventDefault();
        let p = { libelle: null,  new: true };
        let niveauTemp = [...niveau];
        let hasEmptyElement = niveauTemp.some((item) => hasEmptyProperty(item))
        if (hasEmptyElement) {
            notyf.error("Vous ne pouvez pas ajouter un nouveau élément, Var il exsite un élément qui contient un champ vide ou null");
        } else {
            niveauTemp.push(p);
            setNiveau(niveauTemp);
        }
    }

    const inputChangeHandlerData = (e, index, indexX) => {
        if (userType == "ADMIN_YOUNOV") {
            const key = e.target.name;
            const value = e.target.value;
            setHierarchical((prevState) => {
                let newHierarchical = [...prevState]
                newHierarchical[index] = { ...newHierarchical[index], [key]: value }
                return newHierarchical
            })
        }
    }

    const addNew = (e,indexOfOrigineLevel) => {
        e.preventDefault();
        let p = indexOfOrigineLevel == 0 ? { index: indexOfOrigineLevel, libelle: null, code: null, new: true } :
            {
                index: indexOfOrigineLevel, libelle: null, code: null, new: true,
                ...Object.fromEntries(Array.from({ length: indexOfOrigineLevel }).map((_, i) => [`${niveau[i].libelle}`, null]))
            }
        let hierarchicalTemp = [...hierarchical];
        let hasEmptyElement = hierarchicalTemp.some((item) => hasEmptyProperty(item))
        if (hasEmptyElement) {
            notyf.error("Vous ne pouvez pas ajouter un nouveau élément, Car il exsite un élément qui contient un champ vide ou null");
        } else {

            hierarchicalTemp.push(p);
            setHierarchical(hierarchicalTemp);
        }
    }

    const body = useMemo(() => niveau?.map((nv, index) => (
        <TBody key={index}>
            <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }} >
                <TD style={{ width: "99%" }} >
                    {!nv?.new ? <span >{nv?.libelle}</span> :
                        <FormInputAgence
                            style={{ width: "99%" }}
                            id="libelle"
                            type="text"
                            name="libelle"
                            //err={isLibelle}
                            placeholder="Ex: Agence x"
                            value={nv?.libelle || ""}
                            onChange={(e) => inputChangeHandlerLevel(e, index)} />
                    }

                </TD>
        

                <TD style={{ width: "14%" }}>

                    {userType == "ADMIN_YOUNOV" && <CancelIcon onClick={(e) => deleteLevel(index)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />}


                </TD>
            </tr>
        </TBody>
    )), [niveau,hierarchical])

    const elementOfChild = useCallback((indexOfOrigineLevel) => {
        let temp = hierarchical;
        return hierarchical?.filter((iteme, id) => iteme.index == indexOfOrigineLevel).map((nv, index) => {
             const originalIndex = temp.findIndex((item) => item === nv);
            
            return(
            <TBody key={index}>
                <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }} >
                    <TD style={{ width: "100%" }}>
                        <FormInputAgence
                            style={{ width: "95%" }}
                            id="libelle"
                            type="text"
                            name="libelle"
                            //err={isLibelle}
                            placeholder="Ex: Agence x"
                            value={nv?.libelle || ""}
                                onChange={(e) => inputChangeHandlerData(e, originalIndex, indexOfOrigineLevel)} />
                    </TD>
                    <TD style={{ width: "100%" }} >
                        <FormInputAgence
                            style={{ width: "95%" }}
                            id="code"
                            type="text"
                            name="code"
                            //err={isCode}
                            placeholder="EX: CMCIFRPP"
                            value={nv?.code || ""}
                                onChange={(e) => inputChangeHandlerData(e, originalIndex, indexOfOrigineLevel)} />
                    </TD>
                        {Array.from({ length: indexOfOrigineLevel }).map((_, i) => (
                        <TD key={3+i} style={{ width: "100%" }}  >
                            <FormSelect
                                style={{ width: "95%" }}
                                id="bailleur"
                                name={niveau[i].libelle}
                                value={nv?.[niveau[i].libelle] || ""}
                                onChange={(e) => inputChangeHandlerData(e, originalIndex, indexOfOrigineLevel)}
                            >
                                <option value=""></option>
                                    {i > 0 ?
                                        hierarchical.filter((iteme, j) => iteme.index == i && iteme[niveau[i - 1].libelle] == nv?.[niveau[i - 1].libelle])?.map(item => (
                                            <option key={item} value={item.libelle}>{item.libelle}</option>
                                        ))
                          
                                        :
                                        hierarchical.filter((iteme, j) => iteme.index == i)?.map(item => (
                                        <option key={item} value={item.libelle}>{item.libelle}</option>
                                    ))
                                }
                            </FormSelect>
                        </TD>
                    ))}
                    <TD style={{ width: "24%" }}>
                            {userType == "ADMIN_YOUNOV" && <CancelIcon onClick={e => deleteElement(originalIndex, indexOfOrigineLevel)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />}
                    </TD>
                </tr>
            </TBody>
        )})
    }, [hierarchical ])

    const child = useMemo(() => niveau?.map((nv, index) => (
        <FormGroup key={index}>
            <FormLabel htmlFor="countryCode" > Ajouter des {nv.libelle}<div><FontAwesomeIcon icon={faCirclePlus} style={{ display: cannotBeModified ? "none" : "flex", marginLeft: "5px", marginRight: "2px", color: "#2174b980", fontSize: "1.25rem" }} onClick={e => addNew(e,index)} /></div> </FormLabel>
            <Table style={{ marginTop: "10px" }}>
                <THead>
                    <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <TH style={{ width: "45%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Libellé *</TH>
                        <TH style={{ width: "45%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code *</TH>
                        {Array.from({ length: index }).map((_, i) => (
                            <TH key={i} style={{ width: "45%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>{niveau[i].libelle} *</TH>
                        ))}
                        {/* <TH style={{ width: "26%", background: '#809FB8', color: "#F1F4F9", paddingLeft: "8px" }}>Ref *</TH>*/}
                        <TH style={{ width: "10%" }}></TH>
                    </tr>
                </THead>
                {elementOfChild(index) }
            </Table>
        </FormGroup>
    )), [niveau, hierarchical])

   
    return (
      <>
        <div>
          <Accordion expanded={open} onChange={() => setOpen(!open)} >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ fontSize: "xx-large" }} />}
            >
              <Typography>
                Niveaux de gestion
              </Typography>
              <FontAwesomeIcon icon={faCirclePlus}
                              style={{ display: cannotBeModified ? "none" : "flex", marginLeft: "5px", marginRight: "2px", color: "#2174b980", fontSize: "1.25rem" }}              
                              onClick={(e) => {
                                e.stopPropagation(); // important pour éviter toggle accordion
                                addNewNiveau(e);
                              }}/>

            </AccordionSummary>

            <AccordionDetails>
                <EntInfosContainer>
                <EIFormContainer>
                  <EIFormCol>
                          <FormGroup>
                                    <Table style={{ marginTop: "10px" }}>
                                        <THead>
                                            <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                                <TH style={{ width: "88%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Libelle *</TH>
                                             {/*   <TH style={{ width: "45%", background: '#809FB8', color: "#F1F4F9", paddingLeft: "8px" }}>Code  *</TH>*/}
                                                {}
                                               {/* <TH style={{ width: "26%", background: '#809FB8', color: "#F1F4F9", paddingLeft: "8px" }}>Ref *</TH>*/}
                                                <TH style={{ width: "10%" }}></TH>
                                            </tr>
                                        </THead>
                                        {body}
                                    </Table>
                          </FormGroup>
                  </EIFormCol>

                        <EIFormCol>
                            {child}
                        </EIFormCol>

                    </EIFormContainer>
                </EntInfosContainer>
                      
            </AccordionDetails>
           </Accordion>
                
                {
                    <ConfirmationModal
                        show={showModalConfirmation}
                        modalClosed={() => setShowModalConfirmation(false) }
                        title={"Confirmation de suppression"}
                        message={`Êtes-vous sûr de vouloir supprimer cette ligne ?`}
                        confirm={()=>confirmeDeleteLevel(indexLevelTodDelete)}
                        cancel={() => setShowModalConfirmation(false)}
                    />
                }
            </div>
        </>
    );
}

export default InfosLevel;


